import { z } from 'zod';
import { DateTime } from 'luxon';
import { ZONE } from '../../enum/ZONE';
import {
  StammdatenQuestionnaireQuestionKey,
  stammdatenQuestionnaireReqDto,
} from './stammdaten-questionnaire.req.dto';

const { Address, PLZ, Ort } = StammdatenQuestionnaireQuestionKey;

// reuses the real Stammdaten field definitions (lengths, PLZ range); the address is
// optional in that DTO, but here all three fields are required and must not be blank
export const updateParticipantAddressReqDto = z.object({
  [Address]: stammdatenQuestionnaireReqDto.shape[Address].unwrap()
    .trim()
    .min(1),
  [PLZ]: stammdatenQuestionnaireReqDto.shape[PLZ],
  [Ort]: stammdatenQuestionnaireReqDto.shape[Ort].trim().min(1),
  // date-only, no time-of-day: parsed and later stored as UTC so the wall-clock
  // matches what was picked, regardless of server or client zone
  movedAt: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine(
      (value) => {
        const date = DateTime.fromISO(value, { zone: 'utc' });
        return (
          date.isValid &&
          date.toMillis() <=
            DateTime.now().setZone(ZONE).endOf('day').toMillis()
        );
      },
      { message: 'movedAt must be a valid date, not in the future' },
    ),
});
export type UpdateParticipantAddressReqDto = z.infer<
  typeof updateParticipantAddressReqDto
>;
